"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLocale = undefined;

var _i18next = require("i18next");

var _i18next2 = _interopRequireDefault(_i18next);

var _locales = require("./locales/");

var _locales2 = _interopRequireDefault(_locales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultLocale = exports.defaultLocale = "en";

exports.default = function (locales) {
  var i18nConfig = {
    lng: defaultLocale,
    fallbackLng: defaultLocale,
    lowerCaseLng: true,
    resources: locales || _locales2.default
  };

  var newInstance = _i18next2.default.createInstance(i18nConfig, function (err) {
    if (err) return console.log("something went wrong loading i18next", err);
    return null;
  });

  return newInstance;
};